<template>
  <div class="error-tips-all">
    <div class="error-tips-message" v-html="warningMessage"></div>
    <a
      href="https://itss.amh-group.com/amhNet.html"
      target="_blank"
      class="check-internet"
      :class="{ 'check-internet-display': status }"
    >
      >>> 您可以先自助检测网络状况
    </a>
    <div class="error-tips-border"></div>
    <div class="error-tips-time">
      {{ errorTime }}
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import dayjs from 'dayjs'

export default {
  name: 'errorTip',
  props: {
    warningMessage: {
      type: String,
      default: ''
    },
    status: {
      type: Number,
      default: 0
    },
    traceId: {
      type: String,
      default: ''
    },
    errorPath: {
      type: String,
      default: ''
    },
    errorCode: {
      type: String,
      default: ''
    }
  },
  computed: {
    errorTime() {
      return `[${dayjs().format('HH:mm:ss')}](${this.status}) ${this.errorPath} ${
        this.traceId ? ' [ ' + this.traceId + ' ]' : ''
      }${this.errorCode ? '(' + this.errorCode + ')' : ''}`
    }
  }
}
</script>

<style lang="stylus" scoped>
.error-tips-all {
  .error-tips-message {
    display:-webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:3;
    overflow: hidden;
  }
  .check-internet {
    font-size: 12px;
  }
  .check-internet-display {
    display: none;
  }
  .error-tips-border {
    border-top: 1px solid #cccccc;
    margin: 8px 0;
    width: 100%;
  }
  .error-tips-time {
    font-size: 12px;
    color: #999999;
    word-break: break-all;
  }
}
</style>
